import React from 'react';
import { TextField } from '@mui/material';
import { useCustomApplicationEditor } from '../../../../hooks/useCustomApplicationEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const AppTitleEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useCustomApplicationEditor(mode);

  return (
    <TextField
      size="small"
      fullWidth
      required
      label="Title"
      value={request?.title || ''}
      onChange={(e) => updateRequest({ title: e.target.value })}
    />
  );
};

export default AppTitleEditor;
